import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isNarrowMenuViewport } from 'utils/viewport';

import Aux from '../../../../hoc/ReactAux/ReactAux';

function Categories(props) {
  const itemsSidebar = useSelector(state => state.menuReducer.itemsSideBarMenu);
  const [isMobile, setIsMobile] = useState(isNarrowMenuViewport);

  useEffect(() => {
    const syncViewport = () => setIsMobile(isNarrowMenuViewport());
    window.addEventListener('resize', syncViewport);
    syncViewport();
    return () => window.removeEventListener('resize', syncViewport);
  }, []);

  const isOption = itemsSidebar[2].active === true;
  return (
    <div
      className={props.showCategoriesMobile ? 'vr menu-open' : 'vr'}
      aria-label="Categories"
    >
      <aside>
        <ul className="menu-nav" tabIndex={2} id="categories-container">
          {
            <Aux>
              <li
                className={
                  props.showRestaurantsMobile
                    ? 'desktop_hide menu-open'
                    : 'desktop_hide'
                }
                onClick={() => props.toggleRestaurants()}
                aria-expanded={props.showRestaurantsMobile ? 'true' : 'false'}
                role="button"
                aria-label={isOption ? 'Show options' : 'Show restaurants'}
              >
                <b>
                  {isOption ? 'Options' : 'Restaurants'}
                  <i className="d-arrow"></i>
                </b>
              </li>
              {isMobile ? (
                <li
                  className={props.showCategoriesMobile ? 'menu-open' : null}
                  onClick={() => props.toggleCategoriesNavClass()}
                  aria-expanded={props.showCategoriesMobile ? 'true' : 'false'}
                >
                  <b>
                    Categories<i className="d-arrow"></i>
                  </b>
                  <ul>
                    {props.categoriesType.map(item => (
                      <li
                        key={item.id}
                        onClick={() => {
                          props.selectCategory(item.id);
                          window.document
                            .getElementById('orders-items')
                            .focus();
                        }}
                        className={item.active ? 'active' : null}
                        role="button"
                      >
                        <a>{item.name}</a>
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <Fragment>
                  <li
                    className={props.showCategoriesMobile ? 'menu-open' : null}
                    onClick={() => props.toggleCategoriesNavClass()}
                    aria-expanded={
                      props.showCategoriesMobile ? 'true' : 'false'
                    }
                  >
                    <b>
                      Categories<i className="d-arrow"></i>
                    </b>
                  </li>
                  <ul>
                    {props.categoriesType.map(item => (
                      <li
                        key={item.id}
                        onClick={() => {
                          props.selectCategory(item.id);
                          window.document
                            .getElementById('orders-items')
                            .focus();
                        }}
                        className={item.active ? 'active' : null}
                        role="button"
                      >
                        <a>{item.name}</a>
                      </li>
                    ))}
                  </ul>
                </Fragment>
              )}

              <li
                className={
                  props.checkout ? 'desktop_hide menu-open' : 'desktop_hide'
                }
                onClick={() => props.toggleCart()}
                aria-expanded={props.checkout ? 'true' : 'false'}
                role="button"
              >
                <b>
                  Cart<i className="d-arrow"></i>
                </b>
              </li>
            </Aux>
          }
        </ul>
      </aside>
      <div className="cart-menu-category-overlay"></div>
    </div>
  );
}

export default Categories;



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuComponents/Categories/Categories.js